import SanitizedGrid from "../../../components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import React from "react";
import { useFormState } from "react-final-form";
import {
  getBusScheduleDays,
  getBusScheduleType,
} from "../../busSchedules/util";
import CustomLabeled from "../../../components/layout/CustomLabeled";

const WaveInformationSection = () => {
  const { values } = useFormState();

  return (
    <SanitizedGrid container spacing={2}>
      {values.busSchedule ? (
        <>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Wave Information
            </Typography>

            <CustomLabeled name="Last Updated At">
              <Typography>
                {(() => {
                  const createdAt = moment.utc(values.createdAt);
                  const updateAt = moment.utc(values.updatedAt);
                  const diffDate = updateAt.diff(createdAt, "seconds");

                  if (diffDate < 1) {
                    return "-";
                  } else {
                    return updateAt.format("DD / MM / YYYY, HH:mm");
                  }
                })()}
              </Typography>
            </CustomLabeled>
            <CustomLabeled name="Wave Name">
              <Typography>{values.busSchedule.name}</Typography>
            </CustomLabeled>
            <CustomLabeled name="Route Type">
              <Typography>
                {getBusScheduleType(values.busSchedule.type)}
              </Typography>
            </CustomLabeled>
            <CustomLabeled
              name={
                values.busSchedule.type === "to_school"
                  ? "Arrival Time"
                  : "Departure Time"
              }
            >
              <Typography>
                {`${moment(values.busSchedule.arrivalTime, "HH:mm").format(
                  "HH:mm",
                )}`}
              </Typography>
            </CustomLabeled>
            <CustomLabeled name="Days of the Weeks">
              <Typography>{getBusScheduleDays(values.busSchedule)}</Typography>
            </CustomLabeled>
          </Grid>
        </>
      ) : (
        <></>
      )}
    </SanitizedGrid>
  );
};

export default WaveInformationSection;
